import React, { Component } from 'react';
import $ from 'jquery';
import 'moment';
import 'fullcalendar';
import 'fullcalendar/dist/fullcalendar.css';
import { asyncRequest, Entities, Projection, TOMCAT_URL } from 'src/common';
import moment from 'moment';
import CircularProgress from 'material-ui/CircularProgress';
import { withTranslation } from 'react-i18next';

class CalendarSeasonCalculationCalendarAdministration extends Component {
    constructor(props) {
        super(props);
        this.calendarRef = React.createRef();
        this.state = {
            events: [],
            selectedSeasonId: null,
            updatingCalendarDates: false,
        };
    }

    componentWillMount() {
        this.props.fetchByCompanyId(Entities.CALENDAR_SEASON, this.props.selectedCompany, Projection.FULL);
    }

    componentDidUpdate(prevProps) {
        const { calendarSeason } = this.props;
        const prevCalc = prevProps.calendarSeason;

        // If we just finished fetching data, update the calendar events
        if (prevCalc.isFetching && !calendarSeason.isFetching) {
            this.setState({ updatingCalendarDates: false });
            this.updateCalendarEvents();
        }
    }

    updateCalendarEvents = () => {
        const { calendarSeason } = this.props;
        const formattedEvents = this.formatEvents(calendarSeason.items);

        const $calendar = $(this.calendarRef.current);

        $calendar.fullCalendar('removeEvents');
        $calendar.fullCalendar('addEventSource', formattedEvents);
    };

    formatEvents = seasons => {
        if (!seasons || !Array.isArray(seasons)) return [];
        const events = [];

        seasons.forEach(season => {
            const durations = season.calendarSeasonDuration;
            durations.forEach(duration => {
                events.push({
                    id: duration.id || `${season.id}-${duration.startDate}`,
                    title: season.name,
                    start: duration.startDate,
                    // As we store the dates different, we need to adjust the end for each entry so they are displayed correct on the calendar
                    end: moment(duration.endDate).add(1, 'days').format('YYYY-MM-DD'),
                    color: season.calendarColor,
                    rendering: 'background',
                });
            });
        });
        return events;
    };

    componentDidMount() {
        const { t, i18n } = this.props;
        $(this.calendarRef.current).fullCalendar({
            locale: i18n.language,
            header: {
                left: '',
                center: 'title',
                right: 'prev,next today',
            },
            buttonText: {
                today: t('calendar.today'),
                day: t('calendar.day'),
                week: t('calendar.week'),
                month: t('calendar.month'),
                list: t('calendar.list'),
            },
            defaultView: 'month',
            selectable: true,
            selectHelper: true,
            schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source', //TODO: replace with commercial license key
            select: (start, end) => {
                const { selectedSeasonId } = this.state;
                const { calendarSeason } = this.props;

                if (!selectedSeasonId) {
                    // eslint-disable-next-line no-alert
                    alert(t('calendar_season_calculation.error.select_season'));
                    $(this.calendarRef.current).fullCalendar('unselect');
                    return;
                }

                const selectedSeason = calendarSeason.items.find(season => season.id === selectedSeasonId);

                if (selectedSeason) {
                    const formattedStart = start.format('YYYY-MM-DD');
                    const formattedEnd = end.clone().subtract(1, 'days').format('YYYY-MM-DD');
                    this.setState({ updatingCalendarDates: true });

                    asyncRequest({
                        endpoint: `${TOMCAT_URL}api/${Entities.CALENDAR_SEASON.repository}/create-durations/${selectedSeason.id}`,
                        method: 'POST',
                        body: {
                            startDate: formattedStart,
                            endDate: formattedEnd,
                        },
                    })
                        .then(response => {
                            this.props.fetchByCompanyId(
                                Entities.CALENDAR_SEASON,
                                this.props.selectedCompany,
                                Projection.FULL,
                            );
                        })
                        .catch(error => {});
                }

                $(this.calendarRef.current).fullCalendar('unselect');
            },
        });
    }

    componentWillUnmount() {
        if (this.calendarRef.current) {
            $(this.calendarRef.current).fullCalendar('destroy');
        }
    }

    handleSelectSeason = seasonId => {
        this.setState({ selectedSeasonId: seasonId });
    };

    renderAvailableSeasons() {
        const { calendarSeason, t } = this.props;
        const { selectedSeasonId } = this.state;

        const seasons = calendarSeason.items.filter(season => !season.default);
        if (seasons.length === 0) {
            return <div className="alert alert-info">{t('calendar_season_calculation.error.no_seasons')}</div>;
        }
        return (
            <div className="list-group">
                {seasons.map(season => {
                    const isSelected = selectedSeasonId === season.id;
                    return (
                        <button
                            key={season.id}
                            type="button"
                            className={`list-group-item list-group-item-action ${isSelected ? 'active' : ''}`}
                            onClick={() => this.handleSelectSeason(season.id)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                color: isSelected ? '#fff' : 'inherit',
                            }}>
                            <span
                                style={{
                                    backgroundColor: season.calendarColor || 'transparent',
                                    width: '18px',
                                    height: '18px',
                                    borderRadius: '4px',
                                    border: isSelected ? '1px solid #fff' : '1px solid #ccc',
                                    marginRight: '12px',
                                    display: 'inline-block',
                                }}
                            />
                            <span style={{ flexGrow: 1, textAlign: 'left' }}>{season.name}</span>

                            {season.isDefault && (
                                <span className={`badge ${isSelected ? 'badge-light' : 'badge-primary'}`}>Default</span>
                            )}
                        </button>
                    );
                })}
            </div>
        );
    }

    render() {
        const { calendarSeason, t } = this.props;
        const finishFetching = !calendarSeason.isFetching;
        return (
            <div className="col-md-12">
                <div className="col-md-4">
                    <div style={{ padding: '20px 0' }}>
                        <h3>{t('calendar_season_calculation.available_seasons')}</h3>
                        {!finishFetching ? (
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <CircularProgress /> {t('calendar_season_calculation.loading_seasons')}
                            </div>
                        ) : (
                            this.renderAvailableSeasons()
                        )}
                    </div>
                </div>
                <div className="col-md-8">
                    {this.state.updatingCalendarDates && (
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: '#e5e5e5ad',
                                zIndex: 10,
                                position: 'absolute',
                            }}>
                            <CircularProgress />
                            {t('calendar_season_calculation.updating_calendar')}
                        </div>
                    )}
                    <div>
                        <style>{`
                            /* Remove grey background from past days */
                            .fc-unthemed td.fc-past {
                                background: transparent !important;
                            }
                            /* Make background events less washed out */
                            .fc-bgevent {
                                opacity: 0.6 !important;
                            }
                        `}</style>
                        <div ref={this.calendarRef}></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(CalendarSeasonCalculationCalendarAdministration);
